export default __webpack_public_path__ + "static/lets-stick-together-ec2e4716e436f3b91238389d7fb48601.jpg";